import styled, { css } from 'styled-components'
import * as Accordion from '@radix-ui/react-accordion'
import { ArrowDownIcon } from '@velasca/icons/arrow-down'

export const FirstLevelMenuTitle = styled.span<{ isExpanded?: boolean }>`
  font-family: ${({ theme }) => theme.fonts.brand};
  font-weight: 600;
  font-size: 1.5rem;
  color: ${({ theme, isExpanded }) =>
    isExpanded ? theme.colors.primary : theme.colors.text.primary};
  line-height: 1.75rem;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
`

export const FirstLevelMenu = styled.div<{
  $hasChildren: boolean
  selected: boolean
}>`
  display: flex;
  align-items: center;
  color: ${({ theme, selected }) =>
    selected ? theme.colors.primary : theme.colors.text.primary};
  border-bottom: ${({ theme, selected, $hasChildren }) =>
    selected && $hasChildren
      ? `3px solid ${theme.colors.primary}`
      : '3px solid transparent'};
  z-index: 1;
  min-height: 3rem;

  ${FirstLevelMenuTitle} {
    padding-bottom: ${({ $hasChildren }) => ($hasChildren ? '0' : '0.5rem')};
  }
`

export const SecondLevelMenu = styled.div`
  padding-bottom: 1rem;
`

export const SecondLevelMenuTitle = styled.span<{ active: boolean }>`
  font-family: ${({ theme }) => theme.fonts.brand};
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme, active }) =>
    active ? theme.colors.primary : theme.colors.text.primary};
  text-transform: uppercase;
`

export const ThirdLevelMenuTitle = styled.span<{ active: boolean }>`
  font-size: 1.5rem;
  font-family: ${({ theme }) => theme.fonts.brand};
  font-weight: 300;
  color: ${({ theme, active }) =>
    active ? theme.colors.primary : theme.colors.text.primary};
`

export const AccordionTrigger = styled(Accordion.Trigger)`
  border: 0;
  background: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.25rem 0;
`

export const DisclosurePanel = styled.div<{ $hasChildren: boolean }>`
  ${({ $hasChildren }) =>
    $hasChildren &&
    css`
      padding-bottom: 1.25rem;
    `}
`

export const Hr = styled.hr`
  background: ${({ theme }) => theme.colors.border};
  margin: 0.25rem 0;
  height: 1px;
  width: 100%;
  margin-top: -2px;
  border-top: 0;
`

export const AccordionHeader = styled(Accordion.Header)`
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const StyledArrowDownIcon = styled(ArrowDownIcon)<{ $rotate: boolean }>`
  transform: ${({ $rotate }) => ($rotate ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: all 0.2s cubic-bezier(0, 0, 0, 1) 0s;
  margin-bottom: 0.75rem;
`
